"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./CustomForm.css");

var _react = _interopRequireDefault(require("react"));

var _MobxMessageContainer = _interopRequireDefault(require("../../../shared/components/message/MobxMessageContainer"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _map = _interopRequireDefault(require("lodash/map"));

var _mobxReact = require("mobx-react");

var _ContentItem = _interopRequireDefault(require("../../../shared/components/cms/ContentItem"));

var _class;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var FormError = (0, _mobxReact.observer)(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(FormError, _React$Component);

  var _super = _createSuper(FormError);

  function FormError() {
    _classCallCheck(this, FormError);

    return _super.apply(this, arguments);
  }

  _createClass(FormError, [{
    key: "_convertToErrorMessage",
    value: function _convertToErrorMessage(error, index) {
      var errorMessage = "";

      if (error.errorMessageCmsKey) {
        errorMessage = /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
          contentKey: error.errorMessageCmsKey
        });
      } else if (error.errorMessageText) {
        errorMessage = /*#__PURE__*/_react.default.createElement("span", null, error.errorMessageText);
      } else {
        errorMessage = /*#__PURE__*/_react.default.createElement("span", null, error);
      }

      return {
        message: errorMessage,
        className: "error",
        id: "form-level-error-".concat(index),
        icon: "attention",
        closeable: false
      };
    }
  }, {
    key: "_getFormLevelErrorMessages",
    value: function _getFormLevelErrorMessages() {
      var _this = this;

      var messages = [];

      if (this.props.form.hasErrors) {
        var errorMessages = (0, _map.default)(this.props.form.errors.get("form-level-error"), function (error, index) {
          return _this._convertToErrorMessage(error, index);
        });

        if ((0, _isEmpty.default)(errorMessages)) {
          errorMessages = [this._convertToErrorMessage("Please fix all errors below.")];
        }

        messages = messages.concat(errorMessages);
      }

      return messages;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_MobxMessageContainer.default, {
        containerId: this.props.form.messageContainerId,
        type: "message",
        messages: this._getFormLevelErrorMessages()
      });
    }
  }]);

  return FormError;
}(_react.default.Component)) || _class;

var _default = FormError;
exports.default = _default;